import React, { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import api from '../../services/api';
export default function AiReviewButtons({ requestId }) {
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);
  if (!requestId) return null;
  const review = async verdict => {
    setBusy(true);
    try { await api.post('/ai/reviews', { requestId, verdict }); setStatus('Valutazione salvata.'); }
    catch (_) { setStatus('Valutazione non salvata. Riprova.'); }
    finally { setBusy(false); }
  };
  return <Box sx={{ mt: 1 }}><Typography variant="caption">Dopo aver confrontato la proposta con le fonti:</Typography>
    <Button size="small" disabled={busy} onClick={() => review('correct')}>Corretta</Button><Button size="small" disabled={busy} onClick={() => review('incorrect')}>Da correggere</Button>
    {status && <Alert severity="info">{status}</Alert>}</Box>;
}
